export type MobileOs = 'ios' | 'android' | 'other';

export type HelloAppH5Source = 'download' | 'share';

export const parseHelloAppH5Source = (search: string): HelloAppH5Source => {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  return params.get('source') === 'download' ? 'download' : 'share';
};

export const isWechatBrowser = (): boolean => /MicroMessenger/i.test(navigator.userAgent || '');

/** 下载链接防缓存 query 参数名 */
export const DOWNLOAD_URL_TIMESTAMP_PARAM = 't';

/** 为 APK / 下载地址追加当前时间戳，避免 CDN 或浏览器返回旧包 */
export const appendDownloadUrlTimestamp = (url: string, timestamp = Date.now()): string => {
  const trimmed = url.trim();
  if (!trimmed) {
    return '';
  }
  try {
    const parsed = new URL(trimmed);
    parsed.searchParams.set(DOWNLOAD_URL_TIMESTAMP_PARAM, String(timestamp));
    return parsed.toString();
  } catch {
    const sep = trimmed.includes('?') ? '&' : '?';
    return `${trimmed}${sep}${DOWNLOAD_URL_TIMESTAMP_PARAM}=${timestamp}`;
  }
};

export const resolveNativeDownloadUrl = (
  os: MobileOs,
  iosAppStoreUrl: string,
  androidApkUrl: string
): string => {
  if (os === 'ios') {
    return iosAppStoreUrl.trim();
  }
  if (os === 'android') {
    return androidApkUrl.trim();
  }
  return androidApkUrl.trim() || iosAppStoreUrl.trim();
};

/** 尝试唤起 App，超时后跳转下载页（App Store / APK） */
export const openAppWithDownloadFallback = (appUrl: string, downloadUrl: string): void => {
  const app = appUrl.trim();
  const fallback = downloadUrl.trim();
  if (!app) {
    if (fallback) {
      window.location.href = appendDownloadUrlTimestamp(fallback);
    }
    return;
  }
  const startedAt = Date.now();
  window.location.href = app;
  if (!fallback) {
    return;
  }
  window.setTimeout(() => {
    if (Date.now() - startedAt < 4000) {
      window.location.href = appendDownloadUrlTimestamp(fallback);
    }
  }, 2500);
};

export const detectMobileOs = (): MobileOs => {
  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) {
    return 'android';
  }
  if (/iPad|iPhone|iPod/i.test(ua)) {
    return 'ios';
  }
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return 'ios';
  }
  return 'other';
};

/** 将 H5 路由 path 与 query 拼到 Universal Link / App Link 基址上 */
export const buildAppOpenUrl = (
  baseLink: string,
  h5Pathname: string,
  search: string
): string => {
  const trimmed = baseLink.trim();
  if (!trimmed) {
    return '';
  }
  try {
    const base = new URL(trimmed);
    const segment = h5Pathname.startsWith('/') ? h5Pathname.slice(1) : h5Pathname;
    const query = search.startsWith('?') ? search : search ? `?${search}` : '';
    return new URL(`${segment}${query}`, base).toString();
  } catch {
    return trimmed;
  }
};
